export const nullSafeString = (input) => {
  return input === null || input === undefined ? "" : input;
};
